import { getUtcDateString } from ".";
import { TimeZones } from "../models";

export const getUtcDate = (
    date: string | undefined,
    time: string | undefined,
    timeZone: string | undefined
): string | undefined => {
    if (!date || !time || !timeZone) return undefined;

    const dateString = date.split("T")[0];
    const timeString = time.split("T")[1];
    return getUtcDateString(`${dateString}T${timeString}`, timeZone as TimeZones);
};
